import { extractEnergieKennzahlen, calculateEnergieKennzahlen } from './extract/extractKennzahlen';
import { extractEnergieKraftstoffe } from './extract/extractKraftstoffe';
import { extractEnergieStrom } from './extract/extractStrom';
// import { extractEnergieWaerme } from './extract/extractWaerme';
import { extractEnergieWaermeNeu } from './extract/extractWaermeNeu';
import { extractEnergieWasser } from './extract/extractWasser';
import { extractKlimagase } from './extract/extractKlimagase';
import { getEinheitenUmrechnung } from '../../bereiche/dateneingabe/functions/getEinheitUmrechung';
import { getEmissionsFaktor } from './getEmmissionsFaktor';
import { getUmrechungsFaktor } from './getUmrechnungsFaktor';
import { IDs } from '../../helpers/IDs';
import { isValid } from './validData';
import * as Moment from 'moment';
import { processKennzahlenBerechnungCO2 } from './processKennzahlenBerechnungCO2';
import { calculateKennzahlenStrukturiert } from './strukturiert/calculateKennzahlenStrukturiert';
import { Kennzahl, getKennzahl } from './strukturiert/Kennzahl';

export function processKennziffernBerechnung(data: any) {
    data[IDs.KENNZIFFERN_STRUKTURIERT] = {};
    const result: any = {};
    // Wir suchen uns zunächst aus den relevanten Daten die benötigten Informationen und sortieren nach Jahr
    const arr_standort = data[IDs.ENT_STANDORT];
    // Einmal Summe
    // console.log('processKennziffernBerechnung: 1 ---------------');
    processKennziffernBerechnungStandort(data, undefined);
    // Und die Standorte einzeln
    // console.log('processKennziffernBerechnung: 2 ---------------');
    arr_standort.forEach((standort: any) => processKennziffernBerechnungStandort(data, standort));
    // console.log('Kennzahlen berechnet: ', result);
    // Wir müssen jetzt die Gesamt-Kennziffern-Berechnung noch "nachholen"
    // console.log('processKennziffernBerechnung: 3 ---------------');
    calculateKennziffern(data[IDs.KENNZIFFERN_BERECHNET], result, data, undefined);
    calculateDurchschnitt(result);
    calculateEnergieKennzahlen(data, result, undefined);
    calculateKennzahlenStrukturiert(data);
    data[IDs.KENNZIFFERN_BERECHNET] = result;
}
const base: any = {};

export function processKennziffernBerechnungStandort(data: any, standort: any) {
    const result: any = {};
    const startjahr: number = ((data[IDs.ENT_KONFIGURATION] || [])
        .find((item: any) => item.startjahr_datenerfassung) || {}).startjahr_datenerfassung || null;
    const arr_bwl = data[IDs.ENT_BETRIEBSDATEN]
        .filter((item: any) => (!standort || standort.tid === item.standort_tid_orig) && isValid(item, IDs.ENT_BETRIEBSDATEN, data));
    const arr_kennzahlen = data[IDs.ENT_KENNZAHLEN_WERTE_ZENTRAL]
        .filter((item: any) => (!standort || standort.tid === item.standort_tid_orig)/* && isValid(item, IDs.ENT_KENNZAHLEN_WERTE_ZENTRAL, data)*/);
    const arr_sonstige = data[IDs.ENT_SONSTIGE_DATEN].filter((item: any) => !standort || standort.tid === item.standort_tid_orig);
    const arr_maschinen = data[IDs.ENT_MASCHINEN]
        .filter((item: any) =>
            (!standort || standort.tid === item.standort_tid_orig)
            && (
                (item.status || null) !== 2
                || ((item.status || null) === 2 && typeof item.jahr_status === 'number' && item.jahr_status >= startjahr)
            )
            && isValid(item, IDs.ENT_MASCHINEN, data)
        );
    const arr_fahrzeuge = data[IDs.ENT_FAHRZEUGE]
        .filter((item: any) =>
            (!standort || standort.tid === item.standort_tid_orig)
            && (
                (item.status || null) !== 2
                || ((item.status || null) === 2 && typeof item.jahr_status === 'number' && item.jahr_status >= startjahr)
            )
            && isValid(item, IDs.ENT_FAHRZEUGE)
        );
    const arr_standort = data[IDs.ENT_STANDORT];

    const minJahr = 2010;
    const maxJahr = Moment().year();
    for (let jahr = minJahr; jahr <= maxJahr; jahr++) {
        base[jahr] = { jahr };
    }

    arr_kennzahlen.forEach((item: any) => {
        item = item || {};
        if (item.kuerzel === 'mehl_verbrauch' && !isNaN(+item.wert)) {
            const jahr: number = +item.jahr;
            const mehl_verbrauch: number = +item.wert;
            if (!base[jahr]) {
                base[jahr] = { jahr };
            }
            base[jahr].mehl_verbrauch = (base[jahr].mehl_verbrauch || 0) + mehl_verbrauch;
        }
    });
    arr_bwl.forEach((item: any) => {
        const jahr = item.jahr;
        const mitarbeiter = item.anz_mitarbeiter;
        const umsatz = item.umsatz;
        const auslastung = item.auslastung;
        const filialen = arr_standort.length;
        const beheizte_flaeche = item.beheizte_flaeche;
        if (!base[jahr]) {
            base[jahr] = { jahr };
        }
        base[jahr].beheizte_flaeche = (base[jahr].beheizte_flaeche || 0) + beheizte_flaeche;
        base[jahr].mitarbeiter = (base[jahr].mitarbeiter || 0) + mitarbeiter;
        base[jahr].umsatz = (base[jahr].umsatz || 0) + umsatz;
        base[jahr].filialen = (base[jahr].filialen || 0) + filialen;
        if (mitarbeiter > 0 && auslastung > 0) {
            base[jahr].auslastung_base = (base[jahr].auslastung_base || 0) + (mitarbeiter * auslastung);
        }
        // Jetzt die Kennzahlen erstellen
        if (standort) {
            getKennzahl('bwl', 'mitarbeiter', jahr, standort.tid, data).setBereich(Kennzahl.BEREICH_BWL).setName('Mitarbeiter')
                .setValue(mitarbeiter);
            getKennzahl('bwl', 'filialen', jahr, standort.tid, data).setBereich(Kennzahl.BEREICH_BWL).setName('Filialen')
                .setValue(filialen);
            getKennzahl('bwl', 'umsatz', jahr, standort.tid, data).setBereich(Kennzahl.BEREICH_BWL).setName('Umsatz').setEinheit('€')
                .setValue(umsatz);
            getKennzahl('bwl', 'beheizte_flaeche', jahr, standort.tid, data).setBereich(Kennzahl.BEREICH_BWL).setName('Beheizte Fläche')
                .setEinheit('m²').setValue(beheizte_flaeche);
        }
    });
    // 2. Durchlauf für Mittelwerte
    arr_bwl.forEach((item: any) => {
        const jahr = item.jahr;
        const mitarbeiter = base[jahr].mitarbeiter;
        const umsatz = base[jahr].umsatz;
        const auslastung_base = base[jahr].auslastung_base;
        if (umsatz > 0 && mitarbeiter > 0) {
            const umsatz_mitarbeiter = umsatz / mitarbeiter;
            base[jahr].umsatz_mitarbeiter = umsatz_mitarbeiter;
        }
        if (mitarbeiter > 0) {
            const auslastung = auslastung_base / mitarbeiter;
            base[jahr].auslastung = auslastung;
        }
    });
    arr_sonstige.forEach((item: any) => {
        const jahr = item.jahr;
        const erfasst = item.erfasst_von;
        const institution = item.institution;
        if (erfasst) {
            if (base[jahr].erfasst && base[jahr].erfasst !== '') {
                if (base[jahr].erfasst.indexOf(erfasst) === -1) { // Nur wenn es nicht schon drin steht
                    base[jahr].erfasst = base[jahr].erfasst + ', ' + erfasst;
                }
            } else {
                base[jahr].erfasst = erfasst;
            }
        }
        if (institution) {
            if (base[jahr].institution && base[jahr].institution !== '') {
                if (base[jahr].institution.indexOf(institution) === -1) { // Nur wenn es nicht schon drin steht
                    base[jahr].institution = base[jahr].institution + ', ' + institution;
                }
            } else {
                base[jahr].institution = institution;
            }
        }
    });

    extractEnergie(data, base, standort);
    calculateKennziffern(base, result, data, standort);
    calculateDurchschnitt(result);
    calculateEnergieKennzahlen(data, result, standort);
    // Jetzt noch Flags ergänzen
    if (arr_fahrzeuge && arr_fahrzeuge.length > 0) {
        result['flags']['hasFahrzeuge'] = true;
    }
    if (arr_maschinen && arr_maschinen.length > 0) {
        result['flags']['hasMaschinen'] = true;
    }
    if (arr_bwl && arr_bwl.length > 0) {
        result['flags']['hasBetriebsdaten'] = true;
    }
    if (!standort) { // Wenn kein Standort --> SUMME ÜBER ALLES
        data[IDs.KENNZIFFERN_BERECHNET] = result;
    } else {
        if (!data[IDs.KENNZIFFERN_BERECHNET_STANDORT]) {
            data[IDs.KENNZIFFERN_BERECHNET_STANDORT] = {};
        }
        data[IDs.KENNZIFFERN_BERECHNET_STANDORT][standort.tid] = result;
    }
}

function calculateDurchschnitt(result: any) {
    const collect: any = {};
    const average: any = {};
    Object.keys(result).forEach((jahr: any) => {
        const item = result[jahr];
        Object.keys(item).forEach((kz: string) => {
            if (!collect[kz]) {
                collect[kz] = { sum: 0, cnt: 0 };
            }
            if (item[kz] && !isNaN(item[kz])) {
                collect[kz].cnt++;
                collect[kz].sum += item[kz];
            }
        });
    });
    Object.keys(collect).forEach((kz: string) => {
        if (collect[kz].cnt > 0) {
            average[kz] = collect[kz].sum / collect[kz].cnt;
        }
    });
    result.avg = average;
}

function calculateKennziffern(base: any, result: any, data: any, standort: any) {
    // LOG für KMU-API
    console.log('calculate Kennziffern AUSGEFÜHRT');
    Object.keys(base).forEach((jahr: any) => {
        if (isNaN(jahr)) {
            result[jahr] = base[jahr]; // wg. den Flags
            return;
        }
        // CO2 - Zuschlag
        const itemFound = data[IDs.ENT_CO2_SICHERHEITSZUSCHLAG].find((zitem: any) => {
            return +zitem.jahr === +jahr &&
                ((standort && zitem.standort_tid_orig === standort.tid) ||
                    !standort && zitem.standort_tid === -1);
        });

        const co2_zuschlag = itemFound ? itemFound.zuschlag : 0;
        // Faktoren Heizwerte
        const faktor_gas_m3 = getUmrechungsFaktor(data, '', jahr, 'erdgas_m3');
        const faktor_oel_verbrauch_l = getUmrechungsFaktor(data, '', jahr, 'heizoel_leicht');

        const faktor_diesel_verbrauch = getUmrechungsFaktor(data, '', jahr, 'dieselkraftstoffe');
        const faktor_benzin_verbrauch = getUmrechungsFaktor(data, '', jahr, 'ottokraftstoffe');
        const faktor_biodiesel_verbrauch = getUmrechungsFaktor(data, '', jahr, 'biodiesel');
        const faktor_bioethanol_verbrauch = getUmrechungsFaktor(data, '', jahr, 'bioethanol');
        const faktor_lpg_verbrauch = getUmrechungsFaktor(data, '', jahr, 'fluessiggas_l');
        // console.log('Faktoren D/B', faktor_diesel_verbrauch, faktor_benzin_verbrauch);
        // Faktoren Emmission
        const faktor_diesel_co2 = getEmissionsFaktor(data, '', jahr, 'ottokraftstoff');
        const faktor_benzin_co2 = getEmissionsFaktor(data, '', jahr, 'diesel');
        const faktor_erdgas_co2 = getEmissionsFaktor(data, '', jahr, 'erdgas');
        const faktor_lpg_co2 = getEmissionsFaktor(data, '', jahr, 'lpg');
        const faktor_wasserstoff_co2 = getEmissionsFaktor(data, '', jahr, 'wasserstoff');
        const faktor_biodiesel_co2 = getEmissionsFaktor(data, '', jahr, 'bio_diesel');
        const faktor_bioethanol_co2 = getEmissionsFaktor(data, '', jahr, 'bio_ethanol');
        const faktor_oel_co2 = getEmissionsFaktor(data, '', jahr, 'heizoel_leicht');
        const faktor_fw_co2 = getEmissionsFaktor(data, '', jahr, 'fernwaerme_mix');
        // console.log('Strom Proc 1: ', jahr, faktor_strom_co2);
        /*let  faktor_strom_co2 = getEmissionsFaktor(data, '', jahr, 'strom_mix');
        if (base[jahr] && ((base[jahr].faktor_strom_co2 > 0) || base[jahr].faktor_strom_co2 === 0 )) {
             faktor_strom_co2 = base[jahr].faktor_strom_co2;
             // console.log('Strom Proc 2: ', jahr, faktor_strom_co2);
        }*/
        const faktor_strom_co2 = base[jahr].faktor_strom_co2_calc || getEmissionsFaktor(data, '', jahr, 'strom_mix');
        const co2_precalc = base[jahr].co2_strom_precalc;
        const co2_precalc_regenerativ = base[jahr].co2_strom_precalc_regenerativ;
        const item = base[jahr];

        const verbrauch_eigenstrom = item.eigenstrom_verbrauch_kwh || 0;
        // console.log('ITEM', item);
        const strom_verbrauch_fremdbezug = item.verbrauch_strom || 0;
        const strom_verbrauch_renewable = item.verbrauch_strom_renewable || 0;
        const strom_verbrauch_konventionell = item.verbrauch_strom_konventionell || 0;
        // const strom_verbrauch_regenerativ = item.verbrauch_strom_regenerativ || 0;
        const strom_verbrauch_regenerativ = verbrauch_eigenstrom;
        const strom_verbrauch_einkauf_renewable = (item.verbrauch_strom_einkauf_renewable || 0);
        // console.log('strom_verbrauch_einkauf_renewable_'+jahr, standort ? standort.name  : '----', strom_verbrauch_einkauf_renewable, strom_verbrauch_renewable, verbrauch_eigenstrom);
        // console.log('Strom Debug', jahr, verbrauch_eigenstrom, strom_verbrauch_fremdbezug);
        // const strom_verbrauch_gesamt = item.verbrauch_strom || 0;

        const strom_verbrauch_gesamt = strom_verbrauch_fremdbezug + verbrauch_eigenstrom;
        const strom_verbrauch_einkauf = strom_verbrauch_konventionell;
        const strom_verbrauch_einkauf_gesamt = strom_verbrauch_konventionell + strom_verbrauch_einkauf_renewable;
        const strom_kosten_gesamt = item.kosten_strom || 0;
        const eigenstrom_produktion = verbrauch_eigenstrom + (item.eigenstrom_einspeisung_kwh || 0);
        const eigenstrom_verbrauch_quote = eigenstrom_produktion ? (100 / eigenstrom_produktion) * verbrauch_eigenstrom : null;
        const eigenstrom_autarkiegrad = strom_verbrauch_gesamt ? (verbrauch_eigenstrom / strom_verbrauch_gesamt) * 100 : null;

        const gas_verbrauch_m3 = (item.verbrauch_waerme_erdgas_m3 || 0) + (item.verbrauch_waerme_fluessiggas_m3 || 0);
        const gas_verbrauch_kwh = (item.verbrauch_waerme_erdgas_kwh || 0) + (item.verbrauch_waerme_fluessiggas_kwh || 0)
            + ((gas_verbrauch_m3 || 0) * faktor_gas_m3);
        // console.log('GAS', item.verbrauch_waerme_erdgas_kwh, item.verbrauch_waerme_fluessiggas_kwh, gas_verbrauch_m3 , faktor_gas_m3);

        const gas_kosten = (item.kosten_waerme_erdgas || 0) + (item.kosten_waerme_fluessiggas || 0);
        const umsatz_mitarbeiter = item.umsatz / item.mitarbeiter;
        const energiekosten_absolut = item.kosten_total;

        const andere_verbrauch_kwh = item.verbrauch_andere_kwh;
        const andere_kosten = item.kosten_andere_kwh;
        // const fernkaelte_verbrauch_kwh = item.verbrauch_fernkaelte_kwh;
        // const fernkaelte_kosten = item.kosten_fernkaelte_kwh;

        // *************** Kraftstoffe berechnen *******************
        const diesel_kosten = item.diesel_kosten;
        const diesel_verbrauch = item.diesel_verbrauch;
        const benzin_kosten = item.benzin_kosten;
        const benzin_verbrauch = item.benzin_verbrauch;

        const biodiesel_kosten = item.biodiesel_kosten;
        const biodiesel_verbrauch = item.biodiesel_verbrauch;
        const bioethanol_kosten = item.bioethanol_kosten;
        const bioethanol_verbrauch = item.bioethanol_verbrauch;

        const lpg_kosten = item.lpg_kosten;
        const lpg_verbrauch = item.lpg_verbrauch;
        const wasserstoff_kosten = item.wasserstoff_kosten;
        const wasserstoff_kwh = item.wasserstoff_verbrauch || 0;
        const erdgas_kraftstoff_kosten = item.erdgas_kraftstoff_kosten;
        const erdgas_kraftstoff_kwh = item.erdgas_kraftstoff_verbrauch || 0;
        const ladestrom_kosten = item.ladestrom_kosten;
        const ladestrom_kwh = item.ladestrom_verbrauch || 0;
        let ladestrom_co2 = item.ladestrom_co2;
        const kraftstoffe_kosten = (benzin_kosten || 0) + (diesel_kosten || 0) + (ladestrom_kosten || 0) +
            (lpg_kosten || 0) + (wasserstoff_kosten || 0) + (erdgas_kraftstoff_kosten || 0) +
            (biodiesel_kosten || 0) + (bioethanol_kosten || 0);

        const kosten_total_ohne_kraftstoffe = item.kosten_total - kraftstoffe_kosten;

        const benzin_kwh = (benzin_verbrauch || 0) * faktor_benzin_verbrauch;
        const diesel_kwh = (diesel_verbrauch || 0) * faktor_diesel_verbrauch;
        const biodiesel_kwh = (biodiesel_verbrauch || 0) * faktor_biodiesel_verbrauch;
        const bioethanol_kwh = (bioethanol_verbrauch || 0) * faktor_bioethanol_verbrauch;
        const lpg_kwh = (lpg_verbrauch || 0) * faktor_lpg_verbrauch;
        if (!ladestrom_co2 && ladestrom_co2 !== 0) {
            ladestrom_co2 = ladestrom_kwh * faktor_strom_co2;
        }
        const co2_kraftstoffe = (benzin_kwh * faktor_benzin_co2 +
            diesel_kwh * faktor_diesel_co2 +
            lpg_kwh * faktor_lpg_co2 +
            erdgas_kraftstoff_kwh * faktor_erdgas_co2 +
            wasserstoff_kwh * faktor_wasserstoff_co2 +
            biodiesel_kwh * faktor_biodiesel_co2 +
            bioethanol_kwh * faktor_bioethanol_co2 +
            ladestrom_co2);
        // console.log('co2_kraftstoffe', jahr, co2_kraftstoffe);
        // console.log('co2_kraftstoffe detail', jahr, benzin_kwh,faktor_benzin_co2, diesel_kwh, faktor_diesel_co2, lpg_kwh, faktor_lpg_co2,
        //  erdgas_kraftstoff_kwh , faktor_erdgas_co2 , wasserstoff_kwh , faktor_wasserstoff_co2 , biodiesel_kwh ,
        // faktor_biodiesel_co2 , bioethanol_kwh , faktor_bioethanol_co2 ,wasserstoff_kwh , faktor_wasserstoff_co2 ,ladestrom_kwh , faktor_strom_co2);
        const verbrauch_biomasse = (item.verbrauch_waerme_bio_hackschnitzel_kwh || 0) +
            (item.verbrauch_waerme_bio_holzpellets_kwh || 0) +
            (item.verbrauch_waerme_bio_brennholz_kwh || 0);
        const kosten_biomasse = (item.kosten_waerme_bio_hackschnitzel || 0) +
            (item.kosten_waerme_bio_holzpellets || 0) +
            (item.kosten_waerme_bio_brennholz || 0);

        // console.log('Co2-Kraft:', co2_kraftstoffe, benzin_kwh, faktor_benzin_co2);
        // *************** Wasser berechnen *******************
        const wasser_kosten = item.wasser_kosten;
        const wasser_verbrauch_jahr = item.wasser_verbrauch_jahr;
        const wasser_verbrauch_tag = item.wasser_verbrauch_tag;

        // *************** Gesamt berechnen *******************
        const waerme_kwh = item.verbrauch_waerme_kwh;
        const kraftstoff_kwh = benzin_kwh + diesel_kwh + lpg_kwh + wasserstoff_kwh + erdgas_kraftstoff_kwh + ladestrom_kwh + biodiesel_kwh + bioethanol_kwh;
        const gesamtverbrauch = (waerme_kwh || 0) + (kraftstoff_kwh || 0) + (strom_verbrauch_gesamt || 0);

        // const co2_strom =  (strom_verbrauch_gesamt * faktor_strom_co2);
        const co2_strom = co2_precalc;
        const co2_strom_regenerativ = co2_precalc_regenerativ;
        // console.log('CO2 ?', jahr, strom_verbrauch_gesamt, faktor_strom_co2, co2_strom);

        const co2_waerme = item.co2_waerme;
        const co2_emission = (co2_kraftstoffe || 0) + (co2_strom || 0) + (co2_waerme || 0);
        const co2_emission_ohne_kraftstoffe = (co2_strom || 0) + (co2_waerme || 0);

        // Berechnete Kennziffern
        const energiekosten_umsatz = item.umsatz > 0 ? Math.round((item.kosten_total / item.umsatz) * 100 * 100) / 100 : undefined;
        /*if (+jahr === 2020) {
             console.log('KZB', '2020', strom_verbrauch_gesamt, strom_kosten_gesamt, item);
        }*/
        const energieverbrauch_ma = item.mitarbeiter > 0 ? Math.round((gesamtverbrauch / item.mitarbeiter) * 100) / 100 : undefined;
        const energiekosten_ma = item.mitarbeiter > 0 ? Math.round((item.kosten_total / item.mitarbeiter) * 100) / 100 : undefined;
        const energie_gebaeude_flaeche = item.beheizte_flaeche > 0 ?
            Math.round((gesamtverbrauch / item.beheizte_flaeche) * 100) / 100 : undefined;

        const waerme_ma = item.mitarbeiter > 0 ? Math.round((waerme_kwh / item.mitarbeiter) * 100) / 100 : undefined;
        const strom_ma = item.mitarbeiter > 0 ? Math.round((item.verbrauch_strom / item.mitarbeiter) * 100) / 100 : undefined;
        const co2_mitarbeiter = item.mitarbeiter > 0 ? Math.round((co2_emission / item.mitarbeiter) * 100) / 100 : undefined;

        const energie_back_flaeche = item.back_flaeche ? Math.round((gesamtverbrauch / item.back_flaeche) * 100) / 100 : undefined;
        const energie_mehl = item.mehl_verbrauch ? Math.round((gesamtverbrauch / item.mehl_verbrauch) * 100) / 100 : undefined;

        // Flüssiggas zurückrechnen
        const umrechnung = getEinheitenUmrechnung('l', 'fluessiggas');
        const kwh_faktor_id = 'fluessiggas_l';
        const kwh_faktor = getUmrechungsFaktor(data, '', jahr, kwh_faktor_id);
        const fluessiggas_kwh = item.verbrauch_waerme_fluessiggas_kwh || 0;
        const fluessiggas_l = fluessiggas_kwh / kwh_faktor;
        const verbrauch_waerme_fluessiggas_kg_reversed = fluessiggas_l * umrechnung.factor;
        // console.log('FL-REVERSE: ', fluessiggas_kwh, fluessiggas_l, verbrauch_waerme_fluessiggas_kg_reversed);
        // Heizöl umrechnen
        const kwh_faktor_id_hel = 'heizoel_leicht';
        const kwh_faktor_hel = getUmrechungsFaktor(data, '', jahr, kwh_faktor_id_hel);
        const heizoel_kwh = item.verbrauch_waerme_hel_kwh || 0;
        const verbrauch_waerme_hel_liter_reversed = heizoel_kwh / kwh_faktor_hel;
        // console.log('HEL-REVERSE: ', jahr, heizoel_kwh,  verbrauch_waerme_hel_liter_reversed);

        // const verbrauch_eigenstrom = item.eigenstrom_verbrauch_kwh || 0;
        // const anteil_erneuerbar = (verbrauch_eigenstrom / (gesamtverbrauch + verbrauch_eigenstrom)) * 100;
        const anteil_erneuerbar = (verbrauch_eigenstrom / gesamtverbrauch) * 100;

        // VSME - ereuerbare kraftstoffe
        const verbrauch_kraftstoffe_erneuerbar = biodiesel_kwh + bioethanol_kwh;

        // VSME - erneuerbare brennstoffe
        const verbrauch_brennstoffe_erneuerbar = verbrauch_biomasse + (item.verbrauch_waerme_biogas_kwh || 0) + verbrauch_kraftstoffe_erneuerbar;

        // NEU FÜR VSME, FOSSILE BRENNSTOFFE
        const fossile_brennstoffe_kwh = benzin_kwh + diesel_kwh + lpg_kwh + erdgas_kraftstoff_kwh + waerme_kwh;
        const verbrauch_brennstoffe = waerme_kwh + kraftstoff_kwh - verbrauch_brennstoffe_erneuerbar;
        const verbrauch_brennstoffe_gesamt = waerme_kwh + kraftstoff_kwh;
        // Renewable
        // Strom
        const verbrauch_strom_renewable = item.verbrauch_strom_renewable || 0;
        const co2_strom_renewable = item.co2_strom_renewable || 0;
        const eigenstrom_verbrauch = item.verbrauch_eigenstrom_renewable || 0; // Eigenverbrauch = Gesamtproduktion - Netzeinspeisung
        // Wärme
        const verbrauch_waerme_renewable = item.verbrauch_waerme_renewable || 0;
        const co2_waerme_renewable = item.co2_waerme_renewable || 0;
        // Gesamt
        // const verbrauch_renewable = verbrauch_strom_renewable + verbrauch_waerme_renewable + verbrauch_biomasse;
        const verbrauch_renewable = verbrauch_brennstoffe_erneuerbar + strom_verbrauch_einkauf_renewable + verbrauch_eigenstrom;
        const verbrauch_ohne_renewable = gesamtverbrauch - verbrauch_renewable;
        const co2_renewable = co2_strom_renewable + co2_waerme_renewable;
        const co2_ohne_renewable = co2_emission - co2_renewable;
        // if (standort && verbrauch_renewable > 0) {
        //     console.log(jahr, standort.name);
        //     console.log('verbrauch_renewable', verbrauch_renewable);
        //     console.log('verbrauch_strom_renewable', verbrauch_strom_renewable);
        //     console.log('verbrauch_waerme_renewable', verbrauch_waerme_renewable);
        //     console.log('gesamtverbrauch', gesamtverbrauch);
        //     console.log('verbrauch_ohne_renewable', verbrauch_ohne_renewable);
        // }

        // Hinweis: Manche Kennziffern werden direkt in "base" geschrieben und müssen hier nicht nochmal extra gesetzt werden
        result[jahr] = {
            ...base[jahr],
            gesamtverbrauch,
            anteil_erneuerbar,
            umsatz_mitarbeiter,
            strom_ma,
            waerme_ma,
            energiekosten_absolut,
            strom_verbrauch_fremdbezug,
            strom_verbrauch_renewable,
            strom_verbrauch_regenerativ,
            strom_verbrauch_einkauf,
            strom_verbrauch_einkauf_renewable,
            strom_verbrauch_einkauf_gesamt,
            strom_verbrauch_regenerativ_gesamt: strom_verbrauch_regenerativ,
            strom_verbrauch_gesamt,
            strom_kosten_gesamt,
            eigenstrom_verbrauch,
            eigenstrom_verbrauch_gesamt: eigenstrom_verbrauch,
            eigenstrom_verbrauch_temp: 0,
            eigenstrom_autarkiegrad,
            eigenstrom_verbrauch_quote,
            gas_verbrauch_m3,
            gas_verbrauch_kwh,
            gas_kosten,
            andere_verbrauch_kwh,
            andere_kosten,
            diesel_kosten,
            diesel_verbrauch,
            diesel_kwh,
            benzin_kosten,
            benzin_verbrauch,
            benzin_kwh,
            biodiesel_kosten,
            biodiesel_verbrauch,
            biodiesel_kwh,
            bioethanol_kosten,
            bioethanol_verbrauch,
            bioethanol_kwh,
            ladestrom_kosten,
            ladestrom_kwh,
            lpg_kosten,
            lpg_verbrauch,
            lpg_kwh,
            erdgas_kraftstoff_kosten,
            erdgas_kraftstoff_kwh,
            wasserstoff_kosten,
            wasserstoff_kwh,
            wasser_kosten,
            wasser_verbrauch_jahr,
            wasser_verbrauch_tag,
            kraftstoffe_kosten,
            energiekosten_umsatz,    // berechnet
            energiekosten_ma,        // berechnet
            energie_gebaeude_flaeche,// berechnet
            energieverbrauch_ma,     // berechnet
            energie_mehl,            // berechnet
            energie_back_flaeche,    // berechnet
            co2_emission,
            co2_emission_ohne_kraftstoffe,
            co2_kraftstoffe,
            co2_strom,
            co2_strom_regenerativ,
            co2_mitarbeiter,
            waerme_kwh,
            kraftstoff_kwh,
            verbrauch_waerme_fluessiggas_kg_reversed,
            verbrauch_waerme_hel_liter_reversed,
            verbrauch_biomasse,
            kosten_biomasse,
            verbrauch_brennstoffe,
            verbrauch_brennstoffe_erneuerbar,
            verbrauch_brennstoffe_gesamt,
            co2_zuschlag,
            kosten_total_ohne_kraftstoffe,
            fossile_brennstoffe_kwh,
            // Renewable
            verbrauch_strom_renewable,
            co2_strom_renewable,
            verbrauch_waerme_renewable,
            co2_waerme_renewable,
            // Renewable Gesamt
            verbrauch_renewable,
            verbrauch_ohne_renewable,
            co2_renewable,
            co2_ohne_renewable
        };

        processKennzahlenBerechnungCO2(data, result[jahr], jahr, standort);
        if (result[jahr].co2_fussabdruck_total) {
            base['flags'].hasCO2 = true;
        }
    });
}

function extractEnergie(data: any, base: any, standort: any) {
    base['flags'] = {};
    extractEnergieStrom(data, base, standort);
    extractEnergieKraftstoffe(data, base, standort);
    // extractEnergieWaerme(data, base, standort);
    extractEnergieWaermeNeu(data, base, standort);
    extractEnergieWasser(data, base, standort);
    extractEnergieKennzahlen(data, base, standort);
    extractKlimagase(data, base, standort);
}
